import { useCallCenterAgentChannel } from '@/features/callcenter/hooks/useCallCenterAgentChannel';
import { useRealtimePresenceChannel } from '@/hooks/useRealtimeChannelEvents';
import { AuthContext } from '@/providers/auth';
import { useContext } from 'react';

// Null-render, mounted once per shell (alongside NotificationManager) so
// callcenter realtime handlers exist for the whole authenticated session,
// not just while the /dashboard route happens to be open.
export const CallCenterManager = () => {
  const { user } = useContext(AuthContext);

  useCallCenterAgentChannel();

  // Display-only roster presence -- agents join it so managers can see who's
  // online; nothing here ever derives product logic from membership.
  useRealtimePresenceChannel('callcenter.agents', {
    enabled: Boolean(user?.is_callcenter),
  });

  return null;
};
